/**
 * @module services/authorization-execute
 * @description Servicio para ejecutar prestaciones con código de autorización
 */
import api from "./api";

export default {
  /**
   * @description Ejecuta una prestación con código AUTH y token OTP del afiliado
   * @param {string} authorizationCode - Código AUTH-YYYY-XXXXXXXXXX
   * @param {string} memberToken - Token OTP del afiliado
   * @returns {Promise<Object>} Resultado con transactionCode
   */
  execute: (authorizationCode, memberToken) =>
    api
      .post("/authorization-cases/execute", { authorizationCode, memberToken })
      .then((r) => r.data),
};
